import { API_config } from '../config/apiConfig';

const HISTORY_KEY = 'commandHistory';
const apiUrl = API_config.apiUrl;
const authHeader = API_config.authHeader;

export function loadHistory() {
  const stored = localStorage.getItem(HISTORY_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function saveHistory(history) {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}

export function addHistory(entry) {
  const history = loadHistory();
  history.push(entry);
  saveHistory(history);
}

export function updateHistoryStatus(id, status) {
  const history = loadHistory().map(h => h.id === id ? { ...h, status } : h);
  saveHistory(history);
}

export async function fetchDeviceCommands() {
  try {
    const response = await fetch(`${apiUrl}/commands`, {
      headers: {
        'Authorization': authHeader,
      },
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (err) {
    console.error('fetchDeviceCommands error', err);
  }
  return [];
}

export async function sendCommand(deviceId, command) {
  const id = Date.now();
  const entry = {
    id,
    deviceId,
    command: command.description || command.type || command.id,
    timestamp: new Date().toISOString(),
    status: 'pending',
  };
  addHistory(entry);
  try {
    const response = await fetch(`${apiUrl}/commands/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader,
      },
      body: JSON.stringify({ id: command.id, deviceId })
    });
    if (!response.ok) {
      throw new Error('Failed to send command');
    }
    updateHistoryStatus(id, 'sent');
  } catch (err) {
    console.error('sendCommand error', err);
  }
}

